import { render, staticRenderFns } from "./GoodsDetailItemEditor.vue?vue&type=template&id=4cc11906"
import script from "./GoodsDetailItemEditor.vue?vue&type=script&lang=js"
export * from "./GoodsDetailItemEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports